import {Types} from "@Common/types";
import {chain} from "@Common/utils/fs";
import {cs} from "../react/chain-services";
import {consumeContext} from "../react/context";

export const CheckShowPricing = ({next}) => cs(
    ["show", (_, next) => IsShowPricing({next})],
    ({show}) => show && next(),
);

export const IsShowPricing = ({next}) => cs(
    consumeContext("company"),
    consumeContext("userLevels"),
    ({company, userLevels: {userLevel}}) => next(userLevelCanSeePrices({company, userLevel})),
);

export const userLevelCanSeePrices = ({company, userLevel}:{
    company     : Types.Xpresso.Loaders.ContextNameMap['company'],
    userLevel   : Types.Apis.Models.UserLevel,
}) => (
    chain(
        (["Company", "Branch", "Agent"] as const)[userLevel - 3],
        (userLevelName) => company && !company.prefs[`hide${userLevelName}LevelPricing`]
    )
);

